import { login, loginByPhone } from 'api/login/login';
import { loginNew } from 'src/api/project_api';
import { loginSend } from "src/api/delivery/delivery";

const user = {
  state: {
    userName: sessionStorage.getItem('username'),
    isFreeze: JSON.parse(sessionStorage.getItem('isFreeze')),
    userInfo: sessionStorage.getItem('userInfo'),
  },

  mutations: {
    SET_NAME(state, name) {
      state.userName = name;
    },
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_ISFREEZE(state, isFreeze) {
      state.isFreeze = isFreeze;
    }
  },
  actions: {
    login({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        loginNew(data).then(res1 => {
          if (res1.type === 'success') {
            console.log('新账号登录返回信息', res1.data);
            sessionStorage.setItem('authStatus', res1.data.authStatus);
            sessionStorage.setItem('username', res1.data.userName || res1.data.account);
            sessionStorage.setItem('account', res1.data.account);
            sessionStorage.setItem('sessionId1', res1.data.sessionId);
            sessionStorage.setItem('isFreeze', res1.data.isFreeze);
            sessionStorage.setItem('userInfo', JSON.stringify(res1.data));
            commit('SET_NAME', res1.data.userName);
            if (res1.data.authStatus === 2) {
              oldLogin(data).then(() => {
                resolve();
              }).catch(() => {
                reject();
              });
            } else {
              resolve();
            }
          } else {
            reject();
          }
        }).catch(() => {
          reject();
        });
      });
    },
    loginByPhone({ commit }, data) {
      return new Promise((resolve, reject) => {
        loginByPhone(data).then(res => {
          if (res.type === 'success') {
            console.log(res.data)
            sessionStorage.setItem('sessionId', res.data.sessionId);
            sessionStorage.setItem('username', res.data.userName);
            sessionStorage.setItem('userAccount', res.data.userAccount);
            sessionStorage.setItem('userType', res.data.userType);
            sessionStorage.setItem('isFreeze', res.data.isFreeze);
            commit('SET_NAME', res.data.userName);
            commit('SET_USERINFO', res.data);
            commit('SET_ISFREEZE', res.data.isFreeze);
            setTimeout(function () {
              resolve();
            }, 5)
          } else {
            reject(res);
          }
        })
      });
    },
    loginSend({ commit }, data) {
      return new Promise((resolve, reject) => {
        loginSend(data).then(res => {
          if (res.type === 'success') {
            console.log(res.data)
            sessionStorage.setItem('sessionId1', res.data.sessionId);
            sessionStorage.setItem('authStatus', '2');
            sessionStorage.setItem('isFreeze', '0');

            sessionStorage.setItem('username', res.data.userName);
            sessionStorage.setItem('userAccount', res.data.account);
            sessionStorage.setItem('userType', res.data.userType);
            sessionStorage.setItem('loginSend', "ok");
            commit('SET_NAME', res.data.userName);
            commit('SET_USERINFO', res.data);
            commit('SET_ISFREEZE', res.data.isFreeze);
            setTimeout(function () {
              resolve();
            }, 5)
          } else {
            reject(res);
          }
        })
      });
    }
  }
};

export default user;

function oldLogin(account) {
  return new Promise((resolve, reject) => {
    login(account).then(res => {
      if (res.type === 'success') {
        console.log('旧账号登录返回信息', res.data);
        sessionStorage.setItem('sessionId', res.data.sessionId);
        // 登录账号为仲裁员
        if (account.userType == '2') {
          sessionStorage.setItem('username', res.data.userName || res.data.account);
          sessionStorage.setItem('account', res.data.account);
          sessionStorage.setItem('userInfo', res.data);
          commit('SET_NAME', res.data.userName);
        }
        setTimeout(function () {
          resolve();
        }, 5)
      } else {
        console.log('旧账号登录失败')
        reject();
      }
    }).catch(() => {
      reject();
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js